import { FC, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { Backdrop, Button, Modal } from '@mui/material';
import SecondTypeButton from 'src/components/Items/button/SecondTypeButton';
import CustomCheckbox from 'src/components/Items/button/CustomCheckbox';
import PickupDetailsFormModal from '../AddPickupDetails/PickupDetailsForm';
import { useActions } from 'src/hooks/useActions';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import { validateField } from 'src/common/utils/validation';
import { IPickupDetailsFetch } from 'src/models/IPickupDetails';

interface IProps {
  open: boolean;
  handleClose: () => void;
  editPickupDetails: IPickupDetailsFetch;
}

export type IErrorsPdData = {
  location?: string | undefined;
  return_at?: string | undefined;
  description?: string | undefined;
  host_id?: string | undefined;
  for_all?: boolean | undefined;
};

const EditPickupDetailsModal: FC<IProps> = ({ open, handleClose, editPickupDetails }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { updatePickupDetails } = useActions();
  const {
    auth: { role },
    pickupDetails: { pickupDetailsList }
  } = useTypedSelector(state => state);
  const [pd, setPd] = useState<IPickupDetailsFetch>(editPickupDetails);
  const [mainLocation, setMainLocation] = useState('');
  const [check, setCheck] = useState(false);
  const [errors, setErrors] = useState<IErrorsPdData>({});
  const [disable, setDisable] = useState(false);
  const [disableButton, setDisableButton] = useState(false);

  useEffect(() => {
    setPd(editPickupDetails);
  }, [editPickupDetails]);

  const handleInput = (name: string) => (value: any) => {
    name === 'location'
      ? value.location
        ? (setPd({ ...pd, location: value.name }), setMainLocation(value.location))
        : (setPd({ ...pd, [name]: value }), setMainLocation(''))
      : setPd({ ...pd, [name]: value });
  };

  function chengeCheckbox() {
    setPd({ ...pd, for_all: !pd.for_all });
  }

  useEffect(() => {
    if (role !== 'host') {
      pd.for_all ? (setDisable(true), setPd({ ...pd, host_id: null })) : setDisable(false);
    } else setDisable(true);
  }, [open, role, pd.for_all]);

  useEffect(() => {
    JSON.stringify(editPickupDetails) === JSON.stringify(pd)
      ? setDisableButton(true)
      : setDisableButton(false);
  }, [pd]);

  const validateInputs = (): boolean => {
    let location = validateField(pd.location);
    const return_at = validateField(pd.return_at);
    const description = validateField(pd.description);
    let host_id = pd.for_all ? '' : pd.host_id === null ? 'Field can not be empty' : '';

    const isExist = pickupDetailsList.find(
      el => el.location === pd.location && (el.for_all === pd.for_all || pd.host_id === el.host_id)
    );

    if (isExist) {
      location = 'Pickup Details already exist';
      host_id = 'Pickup Details already exist';
      enqueueSnackbar('Pickup Details already exist', {
        variant: 'error'
      });
    }

    setErrors({
      location,
      return_at,
      host_id,
      description
    });
    return [location, return_at, host_id, description].every(el => !el);
  };

  const handleCloseModal = () => {
    setPd(editPickupDetails);
    setCheck(false);
    setErrors({});
    handleClose();
  };

  const handleSubmit = () => {
    setCheck(true);
    if (validateInputs()) {
      setPd(editPickupDetails);
      setCheck(false);
      setErrors({});
      handleCloseModal();

      const updatedPd = pd;
      for (const key in pd) {
        (pd[key as keyof typeof pd] === editPickupDetails[key as keyof typeof editPickupDetails] ||
          pd[key as keyof typeof pd] === '') &&
          delete updatedPd[key as keyof typeof updatedPd];
      }
      mainLocation && updatedPd.location
        ? ((updatedPd.location = `${mainLocation}__${updatedPd.location}`),
          updatePickupDetails(updatedPd as IPickupDetailsFetch, editPickupDetails.id))
        : updatePickupDetails(updatedPd as IPickupDetailsFetch, editPickupDetails.id);
    }
  };

  return (
    <Modal open={open} onClose={handleCloseModal} BackdropComponent={Backdrop} closeAfterTransition>
      <div className='modal modal-850'>
        <div className='modal__title'>Edit Pickup Details</div>
        <PickupDetailsFormModal
          pd={pd}
          setPd={handleInput}
          check={check}
          errors={errors}
          disable={disable}
        />
        {role !== 'host' ? (
          <div className='pd-modal__checkbox-container'>
            <CustomCheckbox
              onChange={chengeCheckbox}
              checked={pd.for_all ? pd.for_all : false}
              name='for all'
            />
            <p className='filter__title'>Default</p>
          </div>
        ) : (
          <></>
        )}
        <div className='col-2 modal__buttons'>
          <SecondTypeButton children='Cancel' onClick={handleCloseModal} />
          <Button
            variant='contained'
            onClick={handleSubmit}
            children='Edit Pickup Details'
            disabled={disableButton}
          />
        </div>
      </div>
    </Modal>
  );
};
export default EditPickupDetailsModal;
